
import { WorkCom } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { Model } from '../../model/model';

/** 
 * point d'entrée générique pour les appels de service Workcom
 * va passer par le service :
 * - chargement du pool local
 * - comparaison des numRevs avec remote
 * - téléchargement si nécessaire
 * - merge
 * - alimentation du modèle
 */
export class WorkcomCall extends WizCommand<any> {


  protected model: Model = null;

  constructor(model: Model, pCallback: Function = null) {
    super();
    this.model = model;
    if(pCallback) {
      this._callback = pCallback;
    }
  }

  private _callback: Function = this.voidCallback.bind(this); // retour par défaut pour traçabilité debug

  public wizExecute(): Promise<any> {
    return new Promise((resolve, reject) => {
      const backFromFind = (wc: WorkCom[]) => {
        this._callback(wc);
        resolve(wc);
      };

      this.model.workcomSyncService.findWorkcoms(backFromFind);
    });
  }

  public voidCallback(result: any): void {
  }
}
